import React from 'react';
import { Label } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import useGetNewUploadVersion from '@api/upload/hooks/useGetNewUploadVersion';

type Props = {
  inspectionSummaryFileName: string;
};

function UploadVersion({ inspectionSummaryFileName }: Props) {
  const { t } = useTranslation();
  const { uploadVersion } = useGetNewUploadVersion(inspectionSummaryFileName, {
    enabled: inspectionSummaryFileName !== undefined,
  });

  return (
    <Label color="blue" basic>
      {t('upload.version')} <Label.Detail>{uploadVersion}</Label.Detail>{' '}
    </Label>
  );
}

export default UploadVersion;
